export enum ExperienceLevelEnum {
  EntryLevel = 1,
  MidLevel = 2,
  Senior = 3
}

export const EXPERIENCE_LEVEL_ENUM_RECORD: Record<ExperienceLevelEnum, string> =
  {
    [ExperienceLevelEnum.EntryLevel]: 'Entry Level',
    [ExperienceLevelEnum.MidLevel]: 'Mid Level',
    [ExperienceLevelEnum.Senior]: 'Senior'
  };
